export default __webpack_public_path__ + "static/media/3.a5040e20.JPG";